import { zodResolver } from '@hookform/resolvers/zod'
import { CheckCircle2 } from 'lucide-react'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Link } from 'react-router'
import { z } from 'zod'
import { Button, Input } from '@/design-system'
import { AuthLayout } from './AuthLayout'
import { useAuth } from './useAuth'

const schema = z
  .object({
    password: z.string().min(12, 'Le mot de passe doit contenir au moins 12 caractères.'),
    confirmation: z.string(),
  })
  .refine((values) => values.password === values.confirmation, {
    path: ['confirmation'],
    message: 'Les mots de passe ne correspondent pas.',
  })
type FormValues = z.infer<typeof schema>

export function ResetPasswordPage() {
  const { updatePassword } = useAuth()
  const [done, setDone] = useState(false)
  const [submitError, setSubmitError] = useState<string | null>(null)
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<FormValues>({ resolver: zodResolver(schema) })
  const submit = handleSubmit(async ({ password }) => {
    setSubmitError(null)
    try {
      await updatePassword(password)
      setDone(true)
    } catch {
      setSubmitError('Le mot de passe n’a pas pu être modifié. Réessayez ou demandez un nouveau lien.')
    }
  })

  return (
    <AuthLayout>
      <div className="auth-card__heading">
        <span className="auth-page__eyebrow">Sécurité du compte</span>
        <h2>Nouveau mot de passe</h2>
        <p>Choisissez au moins 12 caractères et utilisez un mot de passe unique.</p>
      </div>
      {done ? (
        <div className="auth-success" role="status">
          <CheckCircle2 aria-hidden="true" />
          <strong>Mot de passe modifié</strong>
          <Link to="/login">Continuer vers la connexion</Link>
        </div>
      ) : (
        <form
          className="auth-form"
          onSubmit={(event) => {
            void submit(event)
          }}
        >
          <Input
            label="Nouveau mot de passe"
            type="password"
            autoComplete="new-password"
            error={errors.password?.message}
            {...register('password')}
          />
          <Input
            label="Confirmer le mot de passe"
            type="password"
            autoComplete="new-password"
            error={errors.confirmation?.message}
            {...register('confirmation')}
          />
          {submitError ? (
            <div className="auth-form__error" role="alert">
              {submitError}
            </div>
          ) : null}
          <Button type="submit" variant="primary" size="large" loading={isSubmitting}>
            Enregistrer le mot de passe
          </Button>
        </form>
      )}
    </AuthLayout>
  )
}
